/**
 * Filament 4 attaches the modal focus trap to `.fi-modal`, a zero-height element that sits in
 * normal flow at the end of the document. When a modal opens the trap focuses that element, so
 * the browser scrolls it into view and the page jumps to the bottom. Because the modal also
 * locks scrolling, the reader cannot scroll back, and the page is still displaced once the
 * modal closes.
 *
 * Remember where the page was when the modal was asked to open, and put it back as soon as the
 * trap takes focus.
 */
const preserveModalScroll = (): void => {
    let scrollBeforeOpen: number | null = null

    window.addEventListener('open-modal', () => {
        scrollBeforeOpen = window.scrollY
    })

    document.addEventListener('focusin', (event: FocusEvent): void => {
        if (scrollBeforeOpen === null) {
            return
        }

        const target = event.target

        if (!(target instanceof HTMLElement) || !target.classList.contains('fi-modal')) {
            return
        }

        const top = scrollBeforeOpen
        scrollBeforeOpen = null

        if (window.scrollY !== top) {
            window.scrollTo(window.scrollX, top)
        }
    })
}

export default preserveModalScroll
